import { getStoreId } from "$/hooks/use-store-information"
import jobLabelQueries from "$/lib/queries/job-label-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/labels")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) queryClient.prefetchQuery(jobLabelQueries.list({ storeId }))
    return {
      crumbs: "alfred.settings.nav.labels.label",
    }
  },
})
